module.exports = __webpack_public_path__ + "img/thumbnail_PolarBear_f_normal.4b1d1a80.png";